<template>
    <div class="custom-modal-wrap overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
        <div class="relative p-4 w-[600px] h-full md:h-auto max-w-3xl">
            <div class="relative rounded-lg shadow bg-theme-modalbg h-max max-h-screen overflow-y-auto">
                <div class="text-[14px] rounded-lg">
                    <div class="relative border-b border-[#414141] p-[16px]">
                        <h2 class="text-[20px] font-[700] text-white text-center pr-[40px]">Hang On</h2>
                        <span class="absolute right-5 top-5 pointer cursor-pointer hover:opacity-60"  @click.prevent="close()">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.2248 18.8258L5.1748 17.7758L10.9498 12.0008L5.1748 6.22578L6.2248 5.17578L11.9998 10.9508L17.7748 5.17578L18.8248 6.22578L13.0498 12.0008L18.8248 17.7758L17.7748 18.8258L11.9998 13.0508L6.2248 18.8258Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                    <div class="flex mt-[16px] mx-[24px] mb-[24px]">
                        <div class="flex flex-col justify-evenly text-white w-full gap-[32px]">
                            {{ title }}
                            <div class="flex flex-col gap-[14px]">
                                <div class="flex flex-col gap-[4px]" v-for="(each,ind) in locationList" :key="ind">
                                    <div class="text-white text-[16px] font-[700]">{{each.name}}</div>
                                    <div class="text-[#9E9E9E] text-[12px] font-[400]">{{data.name}}</div>
                                </div>
                            </div>

                            <div class="flex justify-evenly text-center gap-[16px]">
                                <button @click="cancel" class="uppercase w-full h-[44px] px-12 py-2 rounded text-white border border-white text-center hover:border-white/90">Cancel Changes</button>
                                <button @click="apply" class="w-full h-[44px] px-12 py-2 rounded text-white bg-theme-green text-center hover:bg-theme-green/90">APPLY</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { mapGetters } from "vuex";

export default defineComponent({
    props: ['title', 'data'],
    setup() {
        const locationList = ref([])
        return {
            locationList
        }
    },
    mounted(){
        this.getAccessibleLocations()
    },
    computed: {
        ...mapGetters({
            vg_userLocation: 'location/list',
        })
    },
    methods: {
        close(){
            this.$emit('close')
        },
        cancel(){
            this.$emit('close') 
        },
        async apply(){
            this.$emit('apply')
        },
        getAccessibleLocations(){
            let allLocation = [this.data.baseLocation, ...this.data.groupLocations]
            let userLocations = this.vg_userLocation.map(each => each.id)
            this.locationList = allLocation.filter(each => userLocations.includes(each.id))
        },
        
    }
})
</script>
